import z from 'zod'
import { nullSafeOptionalString, nullSafeString } from '../shared/schema'
import { UserProfileRole } from '../UserProfile/types'

// this is the dart definition
// required String id,
// int? createdAt,
// String? firstName,
// String? imageUrl,
// String? lastName,
// int? lastSeen,
// Map<String, dynamic>? metadata,
// Role? role,
// int? updatedAt,
export const schema = z.object({
  firstName: nullSafeString(''),
  lastName: nullSafeString(''),
  firstNameCased: nullSafeString(''),
  lastNameCased: nullSafeString(''),
  imageUrl: nullSafeOptionalString(''),
  emailAddress: nullSafeString(''),
  emailDomain: nullSafeString(''),
  requiresInvitation: z.boolean().optional(),
  canvasUserId: nullSafeOptionalString(),
  ltiSource: nullSafeOptionalString(),
  role: z.preprocess(
    (val) => (val as UserProfileRole) ?? UserProfileRole.student,
    z.nativeEnum(UserProfileRole)
  ),
})

export const empty = Object.freeze(
  schema.parse({
    firstName: '',
    lastName: '',
    imageUrl: '',
    emailAddress: '',
    role: UserProfileRole.student,
  })
)

export type FirestoreUserSearch = z.infer<typeof schema>
